import './Loader.css';

const Loader = () => {
    return (
        <div className='loader-body'>
            <div className='loader'>
            </div>
            <div>Waiting for server...</div>
        </div>
    )
}
export default Loader;